import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import {
    initTrackingMiddleware,
    trackingMiddleware
} from './middleware/trackingMiddleware';

import createRootReducer from './reducers';

const configureStore = (initialState, history) => {
    /* eslint-disable no-underscore-dangle */
    const composeEnhancers =
        typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
            ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
                  trace: true,
                  traceLimit: 25
              })
            : compose;
    /* eslint-enable */

    initTrackingMiddleware(initialState.widget);
    const createdRouterMiddleware = routerMiddleware(history);

    const enhancer = composeEnhancers(
        applyMiddleware(createdRouterMiddleware, thunk, trackingMiddleware)
    );

    const store = createStore(createRootReducer(history), initialState, enhancer);

    if (process.env.NODE_ENV !== 'production') {
        if (module.hot) {
            // Enable Webpack hot module replacement for reducers
            module.hot.accept('./reducers', () => {
            /* eslint-disable */
            // const nextRootReducer = require('./reducers').default
            /* eslint-enable */
            store.replaceReducer(createRootReducer(history));
            });
        }
    }

    return store;
};

export default configureStore;
